import axios from "axios";
import React, { useState } from "react";
import { baseurl } from "../../constant";

const RechargeApiDocument = ({ rechargeCallbackUrl }) => {
  const [data, setdats] = useState();
  const [url, setUrl] = useState();

  const token = localStorage.getItem("authToken");

  const submitCallbackurl = async () => {
    const result = await axios.post(baseurl + "callbackUpdateAuth", {
      token: token,
      type: 1,
      url: url,
    });
    setdats(result.data);
  };

  return (
    <div>
      <div class="card shadow mb-4">
        <form
          id="admin_profile"
          enctype="multipart/form-data"
          method="post"
          accept-charset="utf-8"
        />
        <input type="hidden" name="method" value="post" />
        <div class="card-header py-3">
          {data && (
            <h4
              style={{
                backgroundColor: "#d2f4e8",
                borderColor: "#bff0de",
                color: "green",
              }}
            >
              {data.message}
            </h4>
          )}
          <div class="row">
            <div class="col-sm-8">
              <h4>
                <b>Recharge API Document</b>
              </h4>
            </div>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-sm-12">
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    id="rechargeAPI-tab"
                    data-toggle="tab"
                    href="#rechargeAPI"
                    role="tab"
                    aria-controls="rechargeAPI"
                    aria-selected="true"
                  >
                    Recharge API
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="operator-tab"
                    data-toggle="tab"
                    href="#operator"
                    role="tab"
                    aria-controls="operator"
                    aria-selected="true"
                  >
                    Operator
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="circle-tab"
                    data-toggle="tab"
                    href="#circle"
                    role="tab"
                    aria-controls="circle"
                    aria-selected="true"
                  >
                    Circle
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="balanceCheck-tab"
                    data-toggle="tab"
                    href="#balanceCheck"
                    role="tab"
                    aria-controls="balanceCheck"
                    aria-selected="false"
                  >
                    Balance Check API
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="statusCheck-tab"
                    data-toggle="tab"
                    href="#statusCheck"
                    role="tab"
                    aria-controls="statusCheck"
                    aria-selected="false"
                  >
                    Status Check API
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="callBack-tab"
                    data-toggle="tab"
                    href="#callBack"
                    role="tab"
                    aria-controls="callBack"
                    aria-selected="false"
                  >
                    Call Back URL
                  </a>
                </li>
              </ul>
              <div class="tab-content apidoc" id="myTabContent">
                <div
                  class="tab-pane fade show active"
                  id="rechargeAPI"
                  role="tabpanel"
                  aria-labelledby="rechargeAPI-tab"
                >
                  <div class="col-sm-12">
                    <br />
                    <h1>Request API URL</h1>
                    <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                      https://www.payol.in/portal/api/rechargeAuth
                    </p>
                    <hr />
                    <p>
                      <b>Request Method - POST</b>
                    </p>
                  </div>
                  <div class="col-sm-12">
                    <br />
                    <h1>Header Parameter</h1>
                    <table class="table table-bordered table-striped">
                      <tr>
                        <th>#</th>
                        <th>Parameter Key</th>
                        <th>Description</th>
                      </tr>
                      <tr>
                        <td>1.</td>
                        <td>MemberID</td>
                        <td>Your account unique id.</td>
                      </tr>
                      <tr>
                        <td>2.</td>
                        <td>TXNPWD</td>
                        <td>Your account trasaction password.</td>
                      </tr>
                    </table>
                    <p style={{ color: "red" }}>
                      Note:- All Parameter key are case sensitive.
                    </p>
                  </div>
                  <div class="col-sm-12">
                    <br />
                    <h1>Post Parameter</h1>
                    <table class="table table-bordered table-striped">
                      <tr>
                        <th>#</th>
                        <th>Parameter Key</th>
                        <th>Description</th>
                      </tr>
                      <tr>
                        <td>1.</td>
                        <td>mobile</td>
                        <td>Customer Mobile No.</td>
                      </tr>
                      <tr>
                        <td>2.</td>
                        <td>operator</td>
                        <td>Operator Code. Please look into Operator List.</td>
                      </tr>
                      <tr>
                        <td>3.</td>
                        <td>circle</td>
                        <td>Circle Code. Please look into Circle List.</td>
                      </tr>
                      <tr>
                        <td>4.</td>
                        <td>amount</td>
                        <td>Recharge Amount</td>
                      </tr>
                      <tr>
                        <td>5.</td>
                        <td>txnID</td>
                        <td>
                          Unique Trasaction ID Numbers Only. Minimum Lenght
                          Should Be 10 Digit.
                        </td>
                      </tr>
                      <tr>
                        <td>6.</td>
                        <td>response_type</td>
                        <td>
                          1 for JSON, 2 for XML. Default Response Will be in
                          JSON Format
                        </td>
                      </tr>
                    </table>
                    <p style={{ color: "red" }}>
                      Note:- All Parameter key are case sensitive.
                    </p>
                  </div>

                  <div class="col-sm-12">
                    <br />
                    <h1>JSON Response</h1>
                    <p style={{ fontSize: "18px", whiteSpace: "pre" }}>
                      {"{"} <br />
                      "status_code": 200,
                      <br />
                      "status_msg": "OK",
                      <br />
                      "status": "PENDING"
                      <br />, "txnid": "1234567890",
                      <br />
                      "operator_txnid": "4455845865875"
                      {"}"}
                    </p>
                  </div>

                  <div class="col-sm-12">
                    <br />
                    <h1>XML Response</h1>
                    <p style={{ fontSize: "18px", whiteSpace: "pre" }}>
                      &#60;?xml version="1.0"?&#62; &#60;response&#62;
                      <br />
                      &#60;status_code&#62;200&#60;/status_code&#62;
                      <br />
                      &#60;status_msg&#62;OK&#60;/status_msg&#62;
                      <br />
                      &#60;status&#62;FAILED&#60;/status&#62;
                      <br />
                      &#60;txnid&#62;1234567890&#60;/txnid&#62;
                      <br />
                      &#60;opt_msg&#62;IVA_OR_DUPLICATE&#60;/opt_msg&#62;
                      <br />
                      &#60;/response&#62;
                      <br />
                    </p>
                  </div>

                  <div class="col-sm-12">
                    <br />
                    <h1>Response Parameters</h1>
                    <table class="table table-bordered table-striped">
                      <tr>
                        <th>#</th>
                        <th>Parameter Key</th>
                        <th>Description</th>
                      </tr>
                      <tr>
                        <td>1.</td>
                        <td>status_code</td>
                        <td>
                          400 = Variable Related Error <br />
                          401 = Variable Data Related Error <br />
                          200 = Success
                        </td>
                      </tr>
                      <tr>
                        <td>2.</td>
                        <td>status_msg</td>
                        <td>
                          API Success or Error Message according status code.
                        </td>
                      </tr>
                      <tr>
                        <td>3.</td>
                        <td>status</td>
                        <td>
                          PENDING <br />
                          FAILED <br />
                          SUCCESS
                        </td>
                      </tr>
                      <tr>
                        <td>4.</td>
                        <td>txnid</td>
                        <td>Your unique Recharge ID.</td>
                      </tr>
                      <tr>
                        <td>5.</td>
                        <td>operator_txnid</td>
                        <td>Unique Recharge ID from Operator Side.</td>
                      </tr>
                      <tr>
                        <td>6.</td>
                        <td>opt_msg</td>
                        <td>Operator Message.</td>
                      </tr>
                    </table>
                  </div>
                </div>

                <div
                  class="tab-pane fade"
                  id="operator"
                  role="tabpanel"
                  aria-labelledby="operator-tab"
                >
                  <div class="col-sm-12">
                    <br />
                    <h1>Operator List</h1>
                    <table class="table table-bordered table-striped">
                      <tr>
                        <th>#</th>
                        <th>Operator Name</th>
                        <th>Operator Code</th>
                        <th>Type</th>
                      </tr>
                      <tr>
                        <td>1.</td>
                        <td>Airtel</td>
                        <td>AT</td>
                        <td>Prepaid</td>
                      </tr>
                      <tr>
                        <td>2.</td>
                        <td>Vodafone</td>
                        <td>VF</td>
                        <td>Prepaid</td>
                      </tr>
                      <tr>
                        <td>3.</td>
                        <td>BSNL TopUp</td>
                        <td>BR</td>
                        <td>Prepaid</td>
                      </tr>
                      <tr>
                        <td>4.</td>
                        <td>BSNL Special (STV)</td>
                        <td>BV</td>
                        <td>Prepaid</td>
                      </tr>
                      <tr>
                        <td>5.</td>
                        <td>Idea</td>
                        <td>IC</td>
                        <td>Prepaid</td>
                      </tr>
                      <tr>
                        <td>6.</td>
                        <td>Tata Docomo</td>
                        <td>TD</td>
                        <td>Prepaid</td>
                      </tr>
                      <tr>
                        <td>7.</td>
                        <td>Tata Docomo Special</td>
                        <td>DS</td>
                        <td>Prepaid</td>
                      </tr>
                      <tr>
                        <td>8.</td>
                        <td>Airtel</td>
                        <td>ATP</td>
                        <td>Postpaid</td>
                      </tr>
                      <tr>
                        <td>9.</td>
                        <td>Idea</td>
                        <td>IDP</td>
                        <td>Postpaid</td>
                      </tr>
                      <tr>
                        <td>10.</td>
                        <td>Vodafone bill</td>
                        <td>VFP</td>
                        <td>Postpaid</td>
                      </tr>
                      <tr>
                        <td>11.</td>
                        <td>BSNL Mobile</td>
                        <td>BSP</td>
                        <td>Postpaid</td>
                      </tr>
                      <tr>
                        <td>12.</td>
                        <td>LOOP Mobile</td>
                        <td>LMP</td>
                        <td>Postpaid</td>
                      </tr>
                      <tr>
                        <td>13.</td>
                        <td>BSNL Landline</td>
                        <td>BSL</td>
                        <td>Landline</td>
                      </tr>
                      <tr>
                        <td>14.</td>
                        <td>MTNL Landline</td>
                        <td>MTL</td>
                        <td>Landline</td>
                      </tr>
                      <tr>
                        <td>15.</td>
                        <td>Airtel Landline</td>
                        <td>ATL</td>
                        <td>Landline</td>
                      </tr>
                      <tr>
                        <td>16.</td>
                        <td>Reliance NetConnect 3G</td>
                        <td>RNG</td>
                        <td>Datacard</td>
                      </tr>
                      <tr>
                        <td>17.</td>
                        <td>Dish TV</td>
                        <td>DT</td>
                        <td>DTH</td>
                      </tr>
                      <tr>
                        <td>18.</td>
                        <td>BIG TV</td>
                        <td>RB</td>
                        <td>DTH</td>
                      </tr>
                      <tr>
                        <td>19.</td>
                        <td>Videocon DTH</td>
                        <td>VD</td>
                        <td>DTH</td>
                      </tr>
                      <tr>
                        <td>20.</td>
                        <td>Sun Direct</td>
                        <td>SD</td>
                        <td>DTH</td>
                      </tr>
                      <tr>
                        <td>21.</td>
                        <td>Airtel DTH</td>
                        <td>AH</td>
                        <td>DTH</td>
                      </tr>
                      <tr>
                        <td>22.</td>
                        <td>MTNL Top Up</td>
                        <td>AH</td>
                        <td>Prepaid</td>
                      </tr>
                      <tr>
                        <td>23.</td>
                        <td>Tata AIA Life Insurance</td>
                        <td>TLI</td>
                        <td>Insurance</td>
                      </tr>
                      <tr>
                        <td>24.</td>
                        <td>ICICI Prudential Life Ins</td>
                        <td>ILI</td>
                        <td>Insurance</td>
                      </tr>
                      <tr>
                        <td>25.</td>
                        <td>Delhi Jal Board (DJB)</td>
                        <td>DJB</td>
                        <td>Water</td>
                      </tr>
                      <tr>
                        <td>26.</td>
                        <td>Lic Premium</td>
                        <td>LIC</td>
                        <td>Insurance</td>
                      </tr>
                      <tr>
                        <td>27.</td>
                        <td>LIC Premium</td>
                        <td>LP</td>
                        <td>Insurance</td>
                      </tr>
                      <tr>
                        <td>28.</td>
                        <td>Reliance</td>
                        <td>RL</td>
                        <td>Landline</td>
                      </tr>
                      <tr>
                        <td>29.</td>
                        <td>Jio</td>
                        <td>jio</td>
                        <td>Prepaid</td>
                      </tr>
                      <tr>
                        <td>30.</td>
                        <td>Gwalior Municipal Corporation - Water</td>
                        <td>GMCW</td>
                        <td>Water</td>
                      </tr>
                      <tr>
                        <td>31.</td>
                        <td>Hyderabad Metropolitan WS and Sewerage Board</td>
                        <td>HMWSSB</td>
                        <td>Water</td>
                      </tr>
                      <tr>
                        <td>32.</td>
                        <td>Indore Municipal Corporation - Water</td>
                        <td>IMCW</td>
                        <td>Water</td>
                      </tr>
                      <tr>
                        <td>33.</td>
                        <td>Jabalpur Municipal Corporation - Water</td>
                        <td>JMCW</td>
                        <td>Water</td>
                      </tr>
                      <tr>
                        <td>34.</td>
                        <td>Municipal Corporation Jalandhar- Water</td>
                        <td>MCJW</td>
                        <td>Water</td>
                      </tr>
                      <tr>
                        <td>35.</td>
                        <td>Municipal Corporation of Faridabad -Water</td>
                        <td>MCOFW</td>
                        <td>Water</td>
                      </tr>
                      <tr>
                        <td>36.</td>
                        <td>Municipal Corporation of Gurugram (MCG) -Water</td>
                        <td>MCOGW</td>
                        <td>Water</td>
                      </tr>
                      <tr>
                        <td>37.</td>
                        <td>Reliance Jio Postpaid</td>
                        <td>JioP</td>
                        <td>Postpaid</td>
                      </tr>
                      <tr>
                        <td>38.</td>
                        <td>Ajmer Vidyut Vitran Nigam - Rajasthan</td>
                        <td>ARE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>39.</td>
                        <td>APDCL - ASSAM</td>
                        <td>AAE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>40.</td>
                        <td>APEPDCL - ANDHRA PRADESH</td>
                        <td>AEE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>41.</td>
                        <td>APSPDCL - ANDHRA PRADESH</td>
                        <td>ASE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>42.</td>
                        <td>BESCOM - BENGALURU</td>
                        <td>BBE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>43.</td>
                        <td>BESL - BHARATPUR</td>
                        <td>BPE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>44.</td>
                        <td>BEST Undertaking - MUMBAI</td>
                        <td>BME</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>45.</td>
                        <td>BkESL - BIKANER</td>
                        <td>BKE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>46.</td>
                        <td>BSES Rajdhani - DELHI</td>
                        <td>BRE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>47.</td>
                        <td>BSES Yamuna - DELHI</td>
                        <td>BYE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>48.</td>
                        <td>CESC - WEST BENGAL</td>
                        <td>CWE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>49.</td>
                        <td>CESCOM - KARNATAKA</td>
                        <td>CKE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>50.</td>
                        <td>CSPDCL - CHHATTISGARH</td>
                        <td>CCE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>51.</td>
                        <td>Daman and Diu Electricity</td>
                        <td>DDE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>52.</td>
                        <td>DGVCL - GUJARAT</td>
                        <td>DGE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>53.</td>
                        <td>DHBVN - HARYANA</td>
                        <td>DHE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>54.</td>
                        <td>DNHPDCL - DADRA & NAGAR HAVELI</td>
                        <td>DNE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>55.</td>
                        <td>GESCOM - KARNATAKA</td>
                        <td>GKE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>56.</td>
                        <td>HESCOM - KARNATAKA</td>
                        <td>HKE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>57.</td>
                        <td>Himachal Pradesh State Electricity Board</td>
                        <td>HPE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>58.</td>
                        <td>India Power - BIHAR</td>
                        <td>IBE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>59.</td>
                        <td>India Power - WEST BENGAL</td>
                        <td>IPE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>60.</td>
                        <td>Jaipur Vidyut Vitran Nigam - RAJASTHAN</td>
                        <td>JRE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>61.</td>
                        <td>JBVNL - JHARKHAND</td>
                        <td>JBE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>62.</td>
                        <td>Jodhpur Vidyut Vitran Nigam - RAJASTHAN</td>
                        <td>DRE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>63.</td>
                        <td>JUSCO - JAMSHEDPUR</td>
                        <td>JUE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>64.</td>
                        <td>Kota Electricity Distribution - RAJASTHAN</td>
                        <td>KRE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>65.</td>
                        <td>Madhya Kshetra Vitaran - MADHYA PRADESH</td>
                        <td>MME</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>66.</td>
                        <td>Madhya Kshetra Vitaran - MADHYA PRADESH</td>
                        <td>MMEE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>67.</td>
                        <td>MEPDCL - MEGHALAYA</td>
                        <td>MEE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>68.</td>
                        <td>MGVCL - GUJARAT</td>
                        <td>MGE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>69.</td>
                        <td>MSEDC - MAHARASHTRA</td>
                        <td>MDE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>70.</td>
                        <td>Muzaffarpur Vidyut Vitran</td>
                        <td>MBE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>71.</td>
                        <td>NBPDCL - BIHAR</td>
                        <td>NBE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>72.</td>
                        <td>NESCO - ODISHA</td>
                        <td>NOE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>73.</td>
                        <td>Noida Power - NOIDA</td>
                        <td>NUE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>74.</td>
                        <td>Paschim Kshetra Vitaran - MADHYA PRADESH</td>
                        <td>MPE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>75.</td>
                        <td>PGVCL - GUJARAT</td>
                        <td>PGE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>76.</td>
                        <td>PSPCL - PUNJAB</td>
                        <td>PPE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>77.</td>
                        <td>Reliance Energy</td>
                        <td>REE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>78.</td>
                        <td>SBPDCL - BIHAR</td>
                        <td>SBE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>79.</td>
                        <td>SNDL Power - NAGPUR</td>
                        <td>SNE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>80.</td>
                        <td>SOUTHCO - ODISHA</td>
                        <td>SOE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>81.</td>
                        <td>Tata Power - DELHI</td>
                        <td>NDE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>82.</td>
                        <td>Tata Power - MUMBAI</td>
                        <td>TME</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>83.</td>
                        <td>TNEB - TAMIL NADU</td>
                        <td>TNE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>84.</td>
                        <td>Torrent Power</td>
                        <td>TPE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>85.</td>
                        <td>TPADL - AJMER</td>
                        <td>AJE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>86.</td>
                        <td>TSECL - TRIPURA</td>
                        <td>TTE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>87.</td>
                        <td>UGVCL - GUJARAT</td>
                        <td>UGE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>88.</td>
                        <td>UHBVN - HARYANA</td>
                        <td>UHE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>89.</td>
                        <td>UPCL - UTTARAKHAND</td>
                        <td>UKE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>90.</td>
                        <td>UPPCL (RURAL) - UTTAR PRADESH</td>
                        <td>URE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>91.</td>
                        <td>UPPCL (URBAN) - UTTAR PRADESH</td>
                        <td>UPE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>92.</td>
                        <td>WBSEDCL - WEST BENGAL</td>
                        <td>WWE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>93.</td>
                        <td>WESCO - ODISHA</td>
                        <td>WOE</td>
                        <td>Electricity</td>
                      </tr>
                      <tr>
                        <td>94.</td>
                        <td>Maharashtra Natural Gas Limited (MNGL)</td>
                        <td>MNGL</td>
                        <td>GAS</td>
                      </tr>
                      <tr>
                        <td>95.</td>
                        <td>TATA Sky DTH</td>
                        <td>TS</td>
                        <td>DTH</td>
                      </tr>
                      <tr>
                        <td>96.</td>
                        <td>Jio Pos Lite</td>
                        <td>JIOPOS</td>
                        <td>Prepaid</td>
                      </tr>
                      <tr>
                        <td>97.</td>
                        <td>True Balance</td>
                        <td>TBAL</td>
                        <td>Prepaid</td>
                      </tr>
                    </table>
                  </div>
                </div>

                <div
                  class="tab-pane fade"
                  id="circle"
                  role="tabpanel"
                  aria-labelledby="circle-tab"
                >
                  <div class="col-sm-12">
                    <br />
                    <h1>Circle List</h1>
                    <table class="table table-bordered table-striped">
                      <tr>
                        <th>#</th>
                        <th>Circle Name</th>
                        <th>Circle Code</th>
                      </tr>
                      <tr>
                        <td>1.</td>
                        <td>Andhra Pradesh Telangana</td>
                        <td>1</td>
                      </tr>
                      <tr>
                        <td>2.</td>
                        <td>Assam</td>
                        <td>2</td>
                      </tr>
                      <tr>
                        <td>3.</td>
                        <td>Bihar Jharkhand</td>
                        <td>3</td>
                      </tr>
                      <tr>
                        <td>4.</td>
                        <td>Chennai</td>
                        <td>4</td>
                      </tr>
                      <tr>
                        <td>5.</td>
                        <td>Delhi NCR</td>
                        <td>5</td>
                      </tr>
                      <tr>
                        <td>6.</td>
                        <td>Gujarat</td>
                        <td>6</td>
                      </tr>
                      <tr>
                        <td>7.</td>
                        <td>Haryana</td>
                        <td>7</td>
                      </tr>
                      <tr>
                        <td>8.</td>
                        <td>Himachal Pradesh</td>
                        <td>8</td>
                      </tr>
                      <tr>
                        <td>9.</td>
                        <td>Jammu Kashmir</td>
                        <td>9</td>
                      </tr>
                      <tr>
                        <td>10.</td>
                        <td>Karnataka</td>
                        <td>10</td>
                      </tr>
                      <tr>
                        <td>11.</td>
                        <td>Kerala</td>
                        <td>11</td>
                      </tr>
                      <tr>
                        <td>12.</td>
                        <td>Kolkata</td>
                        <td>12</td>
                      </tr>
                      <tr>
                        <td>13.</td>
                        <td>Maharashtra Goa</td>
                        <td>13</td>
                      </tr>
                      <tr>
                        <td>14.</td>
                        <td>Madhya Pradesh Chhattisgarh</td>
                        <td>14</td>
                      </tr>
                      <tr>
                        <td>15.</td>
                        <td>Mumbai</td>
                        <td>15</td>
                      </tr>
                      <tr>
                        <td>16.</td>
                        <td>North East</td>
                        <td>16</td>
                      </tr>
                      <tr>
                        <td>17.</td>
                        <td>Orissa</td>
                        <td>17</td>
                      </tr>
                      <tr>
                        <td>18.</td>
                        <td>Punjab</td>
                        <td>18</td>
                      </tr>
                      <tr>
                        <td>19.</td>
                        <td>Rajasthan</td>
                        <td>19</td>
                      </tr>
                      <tr>
                        <td>20.</td>
                        <td>Tamil Nadu</td>
                        <td>20</td>
                      </tr>
                      <tr>
                        <td>21.</td>
                        <td>UP East</td>
                        <td>21</td>
                      </tr>
                      <tr>
                        <td>22.</td>
                        <td>UP West</td>
                        <td>22</td>
                      </tr>
                      <tr>
                        <td>23.</td>
                        <td>West Bengal</td>
                        <td>23</td>
                      </tr>
                      <tr>
                        <td>24.</td>
                        <td>Jharkhand</td>
                        <td>24</td>
                      </tr>
                    </table>
                  </div>
                </div>

                <div
                  class="tab-pane fade"
                  id="balanceCheck"
                  role="tabpanel"
                  aria-labelledby="balanceCheck-tab"
                >
                  <div class="col-sm-12">
                    <br />
                    <h1>Request API URL</h1>
                    <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                      https://www.payol.in/portal/api/balanceAuth
                    </p>
                    <hr />
                    <p>
                      <b>Request Method - GET</b>
                    </p>
                  </div>
                  <div class="col-sm-12">
                    <br />
                    <h1>Header Parameter</h1>
                    <table class="table table-bordered table-striped">
                      <tr>
                        <th>#</th>
                        <th>Parameter Key</th>
                        <th>Description</th>
                      </tr>
                      <tr>
                        <td>1.</td>
                        <td>MemberID</td>
                        <td>Your account unique id.</td>
                      </tr>
                      <tr>
                        <td>2.</td>
                        <td>TXNPWD</td>
                        <td>Your account trasaction password.</td>
                      </tr>
                    </table>
                    <p style={{ color: "red" }}>
                      Note:- All Parameter key are case sensitive.
                    </p>
                  </div>
                  <div class="col-sm-12">
                    <br />
                    <h1>GET Parameter</h1>
                    <table class="table table-bordered table-striped">
                      <tr>
                        <th>#</th>
                        <th>Parameter Key</th>
                        <th>Description</th>
                      </tr>
                      <tr>
                        <td>1.</td>
                        <td>response_type</td>
                        <td>
                          1 for JSON, 2 for XML. Default Response Will be in
                          JSON Format
                        </td>
                      </tr>
                    </table>
                    <p style={{ color: "red" }}>
                      Note:- All Parameter key are case sensitive.
                    </p>
                  </div>

                  <div class="col-sm-12">
                    <br />
                    <h1>JSON Response</h1>
                    <p style={{ fontSize: "18px", whiteSpace: "pre" }}>
                      {"{"}
                      <br /> "status_code": 200,
                      <br />
                      "status_msg": "OK",
                      <br />
                      "balance": 0.00
                      <br />
                      {"}"}
                    </p>
                  </div>

                  <div class="col-sm-12">
                    <br />
                    <h1>XML Response</h1>
                    <p style={{ fontSize: "18px", whiteSpace: "pre" }}>
                      &#60;?xml version="1.0"?&#62; &#60;response&#62;
                      <br />
                      &#60;status_code&#62;200&#60;/status_code&#62;
                      <br />
                      &#60;status_msg&#62;OK&#60;/status_msg&#62;
                      <br />
                      &#60;balance&#62;0.00&#60;/balance&#62;
                      <br />
                      &#60;/response&#62;
                      <br />
                    </p>
                  </div>

                  <div class="col-sm-12">
                    <br />
                    <h1>Response Parameters</h1>
                    <table class="table table-bordered table-striped">
                      <tr>
                        <th>#</th>
                        <th>Parameter Key</th>
                        <th>Description</th>
                      </tr>
                      <tr>
                        <td>1.</td>
                        <td>status_code</td>
                        <td>
                          400 = Variable Related Error <br />
                          401 = Variable Data Related Error <br />
                          200 = Success
                        </td>
                      </tr>
                      <tr>
                        <td>2.</td>
                        <td>status_msg</td>
                        <td>
                          API Success or Error Message according status code.
                        </td>
                      </tr>
                      <tr>
                        <td>3.</td>
                        <td>balance</td>
                        <td>Your account current balance.</td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="statusCheck"
                  role="tabpanel"
                  aria-labelledby="statusCheck-tab"
                >
                  <div class="col-sm-12">
                    <br />
                    <h1>Request API URL</h1>
                    <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                      https://www.payol.in/portal/api/statusAuth
                    </p>
                    <hr />
                    <p>
                      <b>Request Method - POST</b>
                    </p>
                  </div>
                  <div class="col-sm-12">
                    <br />
                    <h1>Header Parameter</h1>
                    <table class="table table-bordered table-striped">
                      <tr>
                        <th>#</th>
                        <th>Parameter Key</th>
                        <th>Description</th>
                      </tr>
                      <tr>
                        <td>1.</td>
                        <td>MemberID</td>
                        <td>Your account unique id.</td>
                      </tr>
                      <tr>
                        <td>2.</td>
                        <td>TXNPWD</td>
                        <td>Your account trasaction password.</td>
                      </tr>
                    </table>
                    <p style={{ color: "red" }}>
                      Note:- All Parameter key are case sensitive.
                    </p>
                  </div>
                  <div class="col-sm-12">
                    <br />
                    <h1>Post Parameter</h1>
                    <table class="table table-bordered table-striped">
                      <tr>
                        <th>#</th>
                        <th>Parameter Key</th>
                        <th>Description</th>
                      </tr>
                      <tr>
                        <td>1.</td>
                        <td>txnID</td>
                        <td>
                          Unique Trasaction ID Numbers Only. Minimum Lenght
                          Should Be 10 Digit.
                        </td>
                      </tr>
                      <tr>
                        <td>2.</td>
                        <td>response_type</td>
                        <td>
                          1 for JSON, 2 for XML. Default Response Will be in
                          JSON Format
                        </td>
                      </tr>
                    </table>
                    <p style={{ color: "red" }}>
                      Note:- All Parameter key are case sensitive.
                    </p>
                  </div>

                  <div class="col-sm-12">
                    <br />
                    <h1>JSON Response</h1>
                    <p style={{ fontSize: "18px", whiteSpace: "pre" }}>
                      {"{"}"<br />
                      status_code": 200,
                      <br />
                      "status_msg": "OK",
                      <br />
                      "status": "FAILED",
                      <br />
                      "txnid": 41191612523938,
                      <br />
                      "amount": 10,
                      <br />
                      "operator_txnid": ""
                      <br />
                      {"}"}
                    </p>
                  </div>

                  <div class="col-sm-12">
                    <br />
                    <h1>XML Response</h1>
                    <p style={{ fontSize: "18px", whiteSpace: "pre" }}>
                      &#60;?xml version="1.0"?&#62; &#60;response&#62;
                      <br />
                      &#60;status_code&#62;200&#60;/status_code&#62;
                      <br />
                      &#60;status_msg&#62;OK&#60;/status_msg&#62;
                      <br />
                      &#60;status&#62;FAILED&#60;/status&#62;
                      <br />
                      &#60;txnid&#62;1234567890&#60;/txnid&#62;
                      <br />
                      &#60;amount&#62;10&#60;/amount&#62;
                      <br />
                      &#60;operator_txnid&#62;&#60;/operator_txnid&#62;
                      <br />
                      &#60;/response&#62;
                      <br />
                    </p>
                  </div>

                  <div class="col-sm-12">
                    <br />
                    <h1>Response Parameters</h1>
                    <table class="table table-bordered table-striped">
                      <tr>
                        <th>#</th>
                        <th>Parameter Key</th>
                        <th>Description</th>
                      </tr>
                      <tr>
                        <td>1.</td>
                        <td>status_code</td>
                        <td>
                          400 = Variable Related Error <br />
                          401 = Variable Data Related Error <br />
                          200 = Success
                        </td>
                      </tr>
                      <tr>
                        <td>2.</td>
                        <td>status_msg</td>
                        <td>
                          API Success or Error Message according status code.
                        </td>
                      </tr>
                      <tr>
                        <td>3.</td>
                        <td>status</td>
                        <td>
                          PENDING <br />
                          FAILED <br />
                          SUCCESS
                        </td>
                      </tr>
                      <tr>
                        <td>4.</td>
                        <td>txnid</td>
                        <td>Your unique Recharge ID.</td>
                      </tr>
                      <tr>
                        <td>5.</td>
                        <td>operator_txnid</td>
                        <td>Unique Recharge ID from Operator Side.</td>
                      </tr>
                      <tr>
                        <td>6.</td>
                        <td>amount</td>
                        <td>Recharge Amount</td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="callBack"
                  role="tabpanel"
                  aria-labelledby="callBack-tab"
                >
                  <div class="col-sm-12">
                    <br />
                    <h1>Update Callback URL</h1>
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        name="call_back_url"
                        placeholder={rechargeCallbackUrl}
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                      />
                    </div>
                    <div class="form-group">
                      <button
                        type="submit"
                        class="btn btn-primary"
                        onClick={submitCallbackurl}
                      >
                        Save
                      </button>
                    </div>
                    <hr />
                    <p>
                      <b>Request Method - POST</b>
                    </p>
                  </div>
                  <div class="col-sm-12">
                    <br />
                    <h1>Post Parameter</h1>
                    <table class="table table-bordered table-striped">
                      <tr>
                        <th>#</th>
                        <th>Parameter Key</th>
                        <th>Description</th>
                      </tr>
                      <tr>
                        <td>1.</td>
                        <td>status</td>
                        <td>
                          PENDING <br />
                          FAILED <br />
                          SUCCESS
                        </td>
                      </tr>
                      <tr>
                        <td>2.</td>
                        <td>txnid</td>
                        <td>Your unique Recharge ID.</td>
                      </tr>
                      <tr>
                        <td>3.</td>
                        <td>operator_txnid</td>
                        <td>Unique Recharge ID from Operator Side.</td>
                      </tr>
                      <tr>
                        <td>4.</td>
                        <td>amount</td>
                        <td>Recharge Amount</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* </form>{" "} */}
      </div>
    </div>
  );
};

export default RechargeApiDocument;
